import AIStatsWidgetComponent from 'flow/components/ai-coworker/AIStatsWidgetComponent';
import React from 'react';

interface Props {
    count: number;
    isLoading?: boolean;
    hasStats?: boolean;
}

const AIStatsCallCount = ({ count, isLoading, hasStats }: Props) => {
    return (
        <AIStatsWidgetComponent
            i18Key="aicoworker.statistics.numberOfCalls"
            value={count}
            className="bg-green-100 text-3xl dark:bg-green-200"
            isLoading={isLoading}
            hasStats={hasStats}
        />
    );
};

export default AIStatsCallCount;
